import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AnalysisCode, AnalysisCodesByLaboratory } from '@core/core.types';
import { AnalysisCodesService } from '@core/services/analysis-codes.service';
import { Logger } from '@core/services/logger.service';
import {
  LoadAnalysisCodesAction,
  SetAnalysisCodesAction,
} from './analysis-codes.actions';
import { map, switchMap } from 'rxjs';

export interface AnalysisCodesStateModel {
  codesByLaboratory: AnalysisCodesByLaboratory;
}

@State<AnalysisCodesStateModel>({
  name: 'analysisCodes',
  defaults: {
    codesByLaboratory: {},
  },
})
@Injectable()
export class AnalysisCodesState {
  private log = new Logger('AnalysisCodesState');

  constructor(private analysisCodesService: AnalysisCodesService) {}

  @Selector()
  static getCodesByLaboratory(state: AnalysisCodesStateModel) {
    return state.codesByLaboratory;
  }

  @Selector()
  static getCodesForLaboratory(state: AnalysisCodesStateModel) {
    return (laboratory: string) => state.codesByLaboratory[laboratory] || [];
  }

  @Action(LoadAnalysisCodesAction)
  loadAnalysisCodes({ dispatch }: StateContext<AnalysisCodesStateModel>) {
    this.log.debug('LoadAnalysisCodesAction');
    return this.analysisCodesService.getAnalysisCodes().pipe(
      map((codes) =>
        codes.reduce(
          (acc, code) => ({
            ...acc,
            [code.laboratory]: code.analysisCodes,
          }),
          {}
        )
      ),
      switchMap((grouped) => dispatch(new SetAnalysisCodesAction(grouped)))
    );
  }

  @Action(SetAnalysisCodesAction)
  setAnalysisCodes(
    { patchState }: StateContext<AnalysisCodesStateModel>,
    { codesByLaboratory }: SetAnalysisCodesAction
  ) {
    patchState({
      codesByLaboratory,
    });
  }
}
